import { render, staticRenderFns } from "./MnemonicsContent.vue?vue&type=template&id=74e031ed&"
import script from "./MnemonicsContent.vue?vue&type=script&lang=js&"
export * from "./MnemonicsContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports